<template>
  <Modal :id="id" title="Supported Merge Tags">
    <div slot="body" class="modal-body">
      <div v-if="!!email && !!email.supported_tags_list" class="row">
        <template v-for="(tag, t) in email.supported_tags_list">
          <div :key="`tag-${t}`" class="col-12">
            <span class="text-dark font-weight-bold">{{
              `{` + tag.value + `}`
            }}</span>
          </div>
          <div :key="`desc-${t}`" class="col-12">{{ tag.label }}</div>
          <div :key="`hr-${t}`" class="col-12 border-top mt-3 pt-3"></div>
        </template>
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "supported-tags-modal",
      email: null,
    };
  },
  created() {
    this.email = this.options.email;
  },
};
</script>

<style lang="scss" scoped>
.modal-body {
  max-height: 400px;
  overflow: auto;
}
</style>